import type { CityConfig } from "../city-template/types";

export const miamiConfig: CityConfig = {
  city: "Miami",
  state: "Florida",
  stateAbbr: "FL",
  slug: "miami",
  route: "/cities/miami",
  title: "Emergency Passport Miami, FL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Miami, FL — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving the Latin American gateway, cruise capital, international banking hub, and bilingual travel community of South Florida.",
  h1: "Emergency & Expedited Passport Services in Miami, FL",
  heroSubtitle: "Cruise departing from PortMiami in four days and your passport just expired? Art Basel meeting in Basel next week and your passport is still in a visa processing backlog? Family emergency in Havana, Caracas, or Bogotá requiring immediate travel? We help Miami residents — from Brickell bankers to Coral Gables families to Hialeah entrepreneurs — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20panoramic%20view%20of%20downtown%20Miami%20Florida%20skyline%20at%20golden%20sunset%20with%20Biscayne%20Bay%20turquoise%20water%20in%20foreground%2C%20modern%20glass%20skyscrapers%20and%20Brickell%20financial%20district%20reflecting%20warm%20Caribbean%20light%2C%20PortMiami%20cruise%20ships%20visible%20on%20horizon%2C%20palm%20trees%20framing%20the%20scene%2C%20professional%20travel%20photography%20with%20vibrant%20warm%20coral%20and%20teal%20tones%2C%20no%20readable%20text%20or%20signs&width=1800&height=700&seq=miami-hero-2026&orientation=landscape",
  heroImageAlt: "Miami Florida downtown skyline with Biscayne Bay and PortMiami at golden sunset",
  geoPosition: "25.7617;-80.1918",
  geoPlacename: "Miami, Florida",
  lastModified: "2026-06-12",
  regionalAgency: {
    name: "Miami Passport Agency",
    address: "1501 Biscayne Blvd, Suite 210, Miami, FL 33132",
    distance: "Located in the Omni Center area downtown — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Miami", zips: "33101–33199" },
    { name: "Miami Beach", zips: "33109, 33139, 33140, 33141" },
    { name: "Coral Gables", zips: "33114, 33124, 33134, 33146, 33156, 33158" },
    { name: "Hialeah", zips: "33002, 33010–33018" },
    { name: "Doral", zips: "33122, 33126, 33166, 33172, 33178" },
    { name: "Kendall", zips: "33156, 33173, 33176, 33183, 33186" },
    { name: "Brickell / Downtown", zips: "33130, 33131, 33132" },
    { name: "Aventura", zips: "33160, 33180" },
    { name: "Homestead", zips: "33030–33035" },
    { name: "Miami Lakes", zips: "33014, 33016, 33018" },
    { name: "Pinecrest", zips: "33156" },
    { name: "Palmetto Bay", zips: "33157, 33158" },
    { name: "Cutler Bay", zips: "33157, 33189, 33190" },
    { name: "Sunny Isles Beach", zips: "33160" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Miami Agency Access", desc: "Reserved courier access to the Miami Passport Agency — as fast as 24 hours for South Florida travelers with immediate departures." },
    { icon: "ri-ship-line", title: "Cruise Capital Expertise", desc: "PortMiami handles 5M+ cruise passengers annually — the busiest cruise port on Earth. We know cruise line documentation requirements and last-minute boarding scenarios." },
    { icon: "ri-global-line", title: "Latin American Gateway Mastery", desc: "MIA is the primary U.S. hub for travel to Latin America and the Caribbean. We understand visa overlap issues, Spanish-language documentation, and multi-generational family travel." },
    { icon: "ri-building-2-line", title: "International Banking & Corporate Ready", desc: "Brickell's financial district, Latin American headquarters, and multinational corporations depend on us for short-notice international travel to São Paulo, Mexico City, and beyond." },
  ],
  internalLinks: [
    { name: "Fast passport services in Fort Lauderdale, FL", route: "/fortlauderdale" },
    { name: "Expedited passport in Boca Raton, FL", route: "/boca" },
    { name: "Quick passport services in West Palm Beach, FL", route: "/westpalm" },
    { name: "Florida passport services overview", route: "/florida" },
  ],
  fpcOfficeAddress: "1501 Biscayne Blvd, Suite 210, Miami, FL 33132",
  fpcOfficeNote: "Fast Passport Center serves Miami via secure registered courier with direct access to the Miami Passport Agency at 1501 Biscayne Blvd, Suite 210. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Miami residents can ship from any UPS Store, FedEx Office, or post office location across Miami-Dade County.",
  fpcOfficeDistance: "Serving Miami, Miami Beach, Coral Gables, Hialeah, Doral, Kendall, Brickell, Aventura, and all Miami-Dade communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Miami and the greater Miami-Dade County area. From the Brickell financial district to the beaches of Miami Beach, from the family neighborhoods of Kendall and Pinecrest to the international business hub of Doral — we serve all of South Florida's diverse, global community. As a registered U.S. Department of State courier, we have guaranteed submission availability at the Miami Passport Agency — no appointment wait, no agency visit required.",
  nearbyCitiesIntro: "We serve Miami and all Miami-Dade communities including Miami Beach, Coral Gables, Hialeah, Doral, Kendall, Aventura, Homestead, and Sunny Isles Beach. We also serve travelers departing from Miami International Airport and PortMiami who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Miami as simple as possible — with the speed and reliability South Florida's international business community, cruise passengers, and multicultural families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Miami travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Miami travelers encounter unique passport issues — everything from cruise documentation surprises to visa overlap complications to multi-generational family application errors. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Miami travelers — from Brickell bankers to South Beach entrepreneurs to Kendall families — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Miami, FL? Here are the most common ones we hear from South Florida travelers.",
  statePageRoute: "/states/florida",
  statePageName: "Florida",
  servicesIntro: "Whether you need a renewal before a cruise from PortMiami, an emergency passport for a last-minute trip to São Paulo, or a first-time passport for a family visit to Havana — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.flhsmv.gov/",
  dmvLabel: "Florida DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins accepted", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Cruise departing PortMiami in three days? Family emergency in Bogotá or Caracas tonight? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Miami-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Miami residents renew fast — no agency visit required for most renewals. Perfect for Brickell professionals, South Beach residents, and Miami families preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Miami residents through every step — from Little Havana to Doral to Kendall — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your cruise departure, MIA flight, or family visit abroad is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Disney cruise, Caribbean vacation, or family visit to Latin America stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Miami-Dade residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Miami bankers, Latin American business executives, and consultants who travel while their primary passport is in visa processing for China, India, or Brazil.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Miami-area travelers through the process — from poolside water damage at South Beach hotels to humidity warping in the Florida climate.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Perfect for Miami residents on Caribbean cruises or Bahamas weekend trips.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  keywords: "expedited passport Miami, emergency passport Miami FL, same day passport Miami, fast passport Florida, passport renewal Miami, Miami passport courier",
  servicesSchema: [
    { name: "Emergency Passport Miami FL", description: "Urgent passport processing for Miami Florida travelers with immediate departure needs from MIA or PortMiami." },
    { name: "Expedited Passport Renewal Miami FL", description: "Fast passport renewal for Miami Florida residents with a previously-issued passport." },
    { name: "First-Time Passport Miami FL", description: "New passport application services for Miami Florida residents applying for their first passport." },
    { name: "Child Passport Miami FL", description: "Minor passport services for Miami Florida families with children under 16." },
    { name: "Name Change Passport Miami FL", description: "Passport name correction after marriage, divorce, or legal name changes for Miami residents." },
    { name: "Second Passport Miami FL", description: "Second passport services for Miami international banking executives and frequent travelers." },
  ],
  testimonials: [
    {
      name: "Carolina M.",
      location: "Brickell, Miami",
      rating: 5,
      text: "I'm a VP at a Latin American bank and travel to São Paulo, Mexico City, and Bogotá monthly. When my passport was damaged by a coffee spill three days before a deal-closing trip to Brazil, Fast Passport Center got me a replacement in 48 hours. The deal closed. I will never use anyone else.",
      service: "Emergency Replacement",
    },
    {
      name: "The Rodriguez Family",
      location: "Kendall, Miami",
      rating: 5,
      text: "We booked a family cruise from PortMiami and realized our two children's passports had expired. Fast Passport Center processed both in seven business days — we made the cruise. The kids still talk about the Bahamas.",
      service: "Multiple Child Renewals",
    },
    {
      name: "David L.",
      location: "Coral Gables, Miami",
      rating: 5,
      text: "I needed a second passport because my primary one was stuck in a Brazil visa processing backlog for six weeks. Fast Passport Center understood exactly what I needed — a second valid passport for travel to London while the visa office held my primary. Delivered in five business days.",
      service: "Second Passport",
    },
  ],
  facilities: [
    {
      id: "mia-1",
      name: "Miami Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2200 NW 72nd Ave",
      city: "Miami",
      state: "FL",
      zip: "33152",
      phone: "(305) 470-0227",
      hours: "Mon–Fri 8:30 AM – 5:00 PM (appointment required)",
      distance: "Near MIA Airport / Doral area",
      website: "https://tools.usps.com/rcas.htm",
      websiteLabel: "USPS Location",
      notes: "Largest acceptance facility in Miami-Dade. Convenient for Doral and airport-area travelers. Photo services on-site. Appointment recommended — heavy cruise season demand.",
      icon: "ri-mail-line",
    },
    {
      id: "mia-2",
      name: "Miami Beach Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1300 Washington Ave",
      city: "Miami Beach",
      state: "FL",
      zip: "33139",
      phone: "(305) 672-2447",
      hours: "Mon–Fri 9:00 AM – 4:30 PM (appointment required)",
      distance: "South Beach",
      website: "https://tools.usps.com/rcas.htm",
      websiteLabel: "USPS Location",
      notes: "Convenient for South Beach, Mid-Beach, and North Beach residents. Smaller facility — limited daily appointment slots, especially during Art Basel and high season.",
      icon: "ri-mail-line",
    },
    {
      id: "mia-3",
      name: "Coral Gables Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "215 Valencia Ave",
      city: "Coral Gables",
      state: "FL",
      zip: "33134",
      phone: "(305) 443-6683",
      hours: "Mon–Fri 9:00 AM – 5:00 PM",
      distance: "Coral Gables / UM area",
      website: "https://tools.usps.com/rcas.htm",
      websiteLabel: "USPS Location",
      notes: "Serves Coral Gables, University of Miami, and South Miami neighborhoods. Passport photos available. Walk-in hours subject to clerk availability.",
      icon: "ri-mail-line",
    },
    {
      id: "mia-4",
      name: "Hialeah Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "325 E 1st Ave",
      city: "Hialeah",
      state: "FL",
      zip: "33010",
      phone: "(305) 888-1227",
      hours: "Mon–Fri 9:00 AM – 5:00 PM (appointment required)",
      distance: "Hialeah",
      website: "https://tools.usps.com/rcas.htm",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Hialeah and Miami Lakes residents. Spanish-speaking staff available. Busy facility — schedule at least a week in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "mia-5",
      name: "Miami-Dade County Clerk — Downtown",
      type: "County Clerk Passport Acceptance",
      address: "22 NW 1st St",
      city: "Miami",
      state: "FL",
      zip: "33128",
      phone: "(305) 275-1155",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Downtown Miami",
      website: "https://www.miamidade.gov/global/service/passports.page",
      websiteLabel: "Miami-Dade Passports",
      notes: "County-level passport acceptance. Appointment recommended. Photo services not available — bring your own photos. Convenient for downtown and Brickell residents.",
      icon: "ri-government-line",
    },
    {
      id: "mia-6",
      name: "Aventura Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "18021 Biscayne Blvd",
      city: "Aventura",
      state: "FL",
      zip: "33160",
      phone: "(305) 931-1010",
      hours: "Mon–Fri 9:00 AM – 5:00 PM (appointment required)",
      distance: "Aventura / Sunny Isles",
      website: "https://tools.usps.com/rcas.htm",
      websiteLabel: "USPS Location",
      notes: "Serves Aventura, Sunny Isles Beach, and North Miami Beach. Photo services on-site. Call ahead — high seasonal demand from snowbirds.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — in-person visit at Miami Passport Agency at 1501 Biscayne Blvd; as a registered courier, we handle this submission for you", fpc: "Most Miami travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Miami-Specific Guidance", agency: "Generic — no cruise, MIA, or Latin American travel expertise", fpc: "Full PortMiami cruise, MIA airport, and bilingual travel community knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming a Cruise Doesn't Require a Passport",
      description: "Many Miami travelers board Caribbean cruises without realizing closed-loop cruises still require valid passports at some ports. A passport emergency discovered at PortMiami on departure day has no good solution — check documentation requirements months ahead.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Visa Overlap — Primary Passport Stuck in Another Country's Visa Processing",
      description: "Miami's international business community frequently needs to travel while their primary passport is held by the Brazilian, Chinese, or Indian consulate for visa processing. A second passport solves this — but most travelers do not know this option exists until it is too late.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Spanish-Language Documentation Confusion",
      description: "Miami's large Spanish-speaking community often has birth certificates, marriage certificates, and other vital records in Spanish. The State Department requires certified English translations for foreign-language documents. We guide you through exactly what is needed.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Multi-Generational Family Application Errors",
      description: "Miami families frequently apply for grandparents, parents, and children simultaneously for family visits to Cuba, Colombia, or Venezuela. Each application type has different requirements — mixing them up causes cascading rejections.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Humidity Damage to Passport Documents",
      description: "South Florida's subtropical climate causes passport warping, water damage, and mold growth on documents stored in non-climate-controlled spaces. A damaged passport is invalid for international travel. We expedite replacements.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Booking International Flights Without Checking Passport Validity",
      description: "MIA is the primary gateway to Latin America, and many countries in the region require 6 months of passport validity beyond the return date. A passport with four months left may get you denied at the gate for a flight to Brazil, Argentina, or Chile.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or condo." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Miami clients ship from home — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive downtown to the Miami Passport Agency on Biscayne Boulevard." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Miami?", a: "We offer Miami-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 2–9 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit a Miami office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (a Miami post office or county clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Miami address." },
    { q: "I have a cruise departing PortMiami — how fast can you help?", a: "For cruises departing within 3–14 days, our expedited courier service is the fastest option. Standard post office processing takes months. We process cruise passenger passports as fast as 24 hours with reserved agency access. Check your documentation requirements the moment you book — some cruise itineraries require passports even for closed-loop U.S. departures." },
    { q: "My primary passport is stuck in a Brazil/China/India visa backlog — can I get a second passport?", a: "Absolutely. This is one of the most common scenarios we handle for Miami's international business community. A second valid U.S. passport allows you to travel internationally while your primary passport remains with a foreign consulate for visa processing. We expedite second passport applications in 2–9 business days." },
    { q: "What about Spanish-language birth certificates and documents?", a: "The U.S. State Department requires certified English translations for any foreign-language vital records submitted with passport applications. If your birth certificate, marriage certificate, or other documents are in Spanish, we guide you through obtaining certified translations that meet State Department standards." },
    { q: "Does the Miami Passport Agency handle walk-ins?", a: "The Miami Passport Agency (located at 1501 Biscayne Blvd, Suite 210) requires appointments for life-or-death emergency travel only. Walk-ins are rarely accepted. For travel within 3–14 days, our registered courier service is the fastest legally available channel without agency restrictions." },
    { q: "Can you process passports for my whole family at once?", a: "Yes — we process all family passports simultaneously. This is especially common in Miami where multi-generational families travel together to visit relatives in Latin America and the Caribbean. Each family member needs their own form and fee. We keep you updated on all applications at once." },
    { q: "What is the best price for expedited passport service in Miami?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "I'm flying out of MIA to São Paulo — how do I check if my passport is valid?", a: "Brazil requires U.S. passports to be valid for the entire duration of stay. Many other Latin American countries require 6 months of validity beyond your return date. We review your itinerary and flag any validity issues before you submit — so you do not get denied at the MIA gate." },
    { q: "Can you help with passport photos in Miami?", a: "We provide exact photo specifications so your photos meet State Department standards. Miami has many photo services (CVS, Walgreens, UPS Stores, AAA), but not all understand the strict requirements. We review your photos before submission to catch issues like wrong background shade, shadows, or sizing problems." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Miami Residents",
    intro: "Miami's unique position as the Western Hemisphere's international crossroads creates passport timing challenges unlike any other U.S. city. From cruise ship departure deadlines to Latin American business travel to multi-generational family visits — here's what Miami travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "MIA — Miami International Airport",
        subtitle: "America's Latin American gateway, 45M+ annual passengers, 100+ international destinations",
        description: "Miami International is the primary U.S. hub for travel to Latin America and the Caribbean, with more flights to the region than any other American airport. American Airlines operates a massive Latin American hub here. MIA handles 45 million passengers annually with nonstop service to virtually every major city in the Americas — São Paulo, Buenos Aires, Bogotá, Lima, Santiago, Mexico City, and 100+ international destinations. The airport's Latin focus means passport and visa issues are a daily reality for Miami travelers.",
        tip: "Many Latin American countries require 6 months of passport validity beyond your return date. A passport with four months left will get you denied at the MIA gate for flights to Brazil, Argentina, Chile, and several other destinations. Check validity the moment you book.",
      },
      {
        icon: "ri-ship-line",
        title: "PortMiami — Cruise Capital of the World",
        subtitle: "5M+ cruise passengers annually, 20+ cruise lines, departures year-round",
        description: "PortMiami is the busiest cruise port on Earth, handling more than 5 million passengers annually across Carnival, Royal Caribbean, Norwegian, MSC, Disney, and Virgin Voyages. Cruise passengers face a unique passport reality: many believe closed-loop cruises (departing and returning from the same U.S. port) do not require passports. While U.S. citizens can technically board some closed-loop cruises with just a birth certificate and ID, many Caribbean ports of call require passports for disembarkation — and emergency medical evacuations from foreign ports absolutely require valid passports.",
        tip: "Never board a cruise without a valid passport, regardless of cruise line policy. A medical emergency requiring evacuation from a foreign port without a valid passport is a consular nightmare. Crew members will confirm this — it happens more often than cruise lines advertise.",
      },
      {
        icon: "ri-building-2-line",
        title: "Brickell & International Banking — Latin American Business Hub",
        subtitle: "Brickell financial district, multinational Latin American headquarters, foreign consulates",
        description: "Brickell is the second-largest financial district in the United States outside of New York, with major Latin American banks, multinational corporations, and private equity firms operating regional headquarters here. Miami executives travel regularly to São Paulo, Mexico City, Bogotá, and Santiago — often on 1–2 week booking windows when deals accelerate. Many also face the visa overlap problem: primary passport held by the Brazilian or Chinese consulate for weeks while business travel to another region is needed immediately.",
        tip: "Brickell executives should maintain a second passport. When your primary passport is held by a foreign consulate for visa processing, a second valid U.S. passport lets you continue traveling. We expedite second passports in 2–9 business days.",
      },
      {
        icon: "ri-global-line",
        title: "Bilingual & Multicultural Family Travel",
        subtitle: "Largest Cuban, Venezuelan, Colombian, and Haitian diasporas in the U.S.",
        description: "Miami is home to the largest concentrations of Cuban-Americans, Venezuelan-Americans, Colombian-Americans, Haitian-Americans, and Nicaraguan-Americans in the United States. Multi-generational family travel to Latin America and the Caribbean is woven into the fabric of daily life — holidays in Havana, summer visits to Medellín, family weddings in Caracas, quinceañeras in Managua. These trips often involve first-time passport applicants, multi-generational document requirements, and Spanish-language vital records needing certified translations.",
        tip: "Family applications involving grandparents, parents, and children require different forms and documentation for each person. Our checklists prevent the cascading errors that happen when families try to navigate the process on their own — especially when vital records are in Spanish.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "The Visa Overlap Reality — Miami's Hidden Passport Crisis",
      description: "Miami has one of the highest concentrations of foreign consulates in the United States — Brazil, Colombia, Argentina, Chile, Peru, and dozens more. Miami residents frequently need visas for business or family travel to Latin America, which means their primary passport is physically held by a consulate for 2–8 weeks. During that window, any other international travel becomes impossible — unless you have a second valid passport. This is the single most under-recognized passport challenge in Miami.",
    },
  },
  destinations: {
    title: "Where Miami Travelers Go — And Why Passports Get Urgent",
    intro: "Miami's deep ties to Latin America and the Caribbean create a travel profile unlike any other U.S. city. Here are the destinations that drive passport demand — and the urgency patterns we see.",
    stats: [
      { stat: "45%", label: "of Miami expedited requests are Latin America and Caribbean-related — family visits, business travel, and cruise departures" },
      { stat: "1–2 Weeks", label: "average lead time Miami travelers have from trip booking to international departure — the shortest in the U.S." },
      { stat: "Nov–Feb", label: "peak season when holiday family travel, cruise high season, and Art Basel international arrivals collide" },
      { stat: "24 Hours", label: "shortest turnaround we have accommodated for a Brickell banker departing to São Paulo" },
    ],
    destinations: [
      { name: "Cuba", context: "Family visits, Havana heritage travel, cultural exchanges, humanitarian travel. Miami is home to the largest Cuban-American community in the world — Cuba travel is a deeply personal, generational priority", urgency: "Family emergencies create same-day departure needs — passport must always be current for Cuban-American families", icon: "ri-map-pin-2-line" },
      { name: "Colombia & Venezuela", context: "Medellín, Bogotá, and Cartagena for the largest Colombian diaspora in the U.S.; Caracas family visits for the largest Venezuelan community abroad. Business travel for Miami's Latin American banking sector", urgency: "Holiday travel peaks November through January — multi-generational family trips require coordinated passport applications", icon: "ri-map-pin-2-line" },
      { name: "Brazil & Argentina", context: "São Paulo and Rio de Janeiro for international banking and private equity; Buenos Aires for business, culture, and family visits. MIA-São Paulo is one of the busiest U.S.-South America routes", urgency: "Brazil requires visas for U.S. citizens — passport held by consulate for 2–6 weeks, creating need for second passport during processing", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Bahamas", context: "Cruise departures from PortMiami to Nassau, Cozumel, Grand Cayman, Jamaica, Dominican Republic, and the Eastern/Western Caribbean; resort vacations and destination weddings", urgency: "Cruise bookings made 2–6 weeks out — passengers often discover passport issues at final payment deadline", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Central America", context: "Mexico City and Cancún for business and leisure; Panama City for Copa Airlines hub connections; Costa Rica and Nicaragua for family heritage travel", urgency: "Business travel to Mexico and Central America often confirmed 1–2 weeks before departure", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "Art Basel meetings in Basel, Switzerland; London and Madrid for international banking; Milan and Paris for Miami's fashion and design industry; Barcelona for cruise connections", urgency: "Art Basel and fashion week travel dates are fixed and unmovable — passport must be ready when the art world convenes", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other South Florida Service Areas",
    crossLinksDesc: "We serve travelers across South Florida with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Fort Lauderdale", route: "/fortlauderdale" },
      { name: "Boca Raton", route: "/boca" },
      { name: "West Palm Beach", route: "/westpalm" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Brickell", address: "1200 Brickell Ave, Miami, FL 33131", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — South Beach", address: "501 Collins Ave, Miami Beach, FL 33139", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Coral Gables", address: "2201 Ponce de Leon Blvd, Coral Gables, FL 33134", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "The UPS Store — Doral", address: "10725 NW 58th St, Doral, FL 33178", hours: "Call for hours", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "Walgreens — Kendall", address: "8701 SW 137th Ave, Miami, FL 33183", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "FedEx Office — Downtown Miami", address: "200 S Biscayne Blvd, Miami, FL 33131", hours: "Call for hours", website: "https://www.office.fedex.com/default/office" },
    { name: "CVS Pharmacy — Hialeah", address: "900 W 49th St, Hialeah, FL 33012", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Aventura", address: "2950 Aventura Blvd, Aventura, FL 33180", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
  ],
  dmvLocations: [
    {
      name: "Miami-Dade DMV — Coral Reef",
      address: "14653 SW 122nd Ave, Miami, FL 33186",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "Miami-Dade DMV — Mall of the Americas",
      address: "7795 W Flagler St, Miami, FL 33144",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Full-service DMV office. REAL ID available. Central location convenient for most Miami-Dade residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MIA",
      name: "Miami International Airport",
      distance: "About 8 miles from downtown Miami",
      address: "2100 NW 42nd Ave, Miami, FL 33126",
      note: "America's primary gateway to Latin America and the Caribbean — 45M+ annual passengers. Nonstop service to 100+ international destinations. American Airlines Latin American hub. Major cargo hub and one of the busiest international airports in the world.",
      flightUrl: "https://www.miami-airport.com/",
      flightLabel: "MIA Airport Website",
      featured: true,
    },
    {
      code: "FLL",
      name: "Fort Lauderdale-Hollywood International Airport",
      distance: "About 28 miles north of downtown Miami",
      address: "100 Terminal Dr, Fort Lauderdale, FL 33315",
      note: "Major alternative airport for South Florida travelers. Extensive Caribbean and Latin American service. Popular for cruise passengers connecting to Port Everglades. Often more affordable than MIA for domestic connections.",
      flightUrl: "https://www.broward.org/airport/",
      flightLabel: "FLL Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the Florida Department of Health Vital Statistics. Online, mail, or in-person at the Miami-Dade vital records office. Serving all Florida counties.",
      url: "https://www.floridahealth.gov/certificates-and-registries/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the Florida Department of Health Vital Statistics. Required for estate and legal matters in Miami-Dade County.",
      url: "https://www.floridahealth.gov/certificates-and-registries/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage records from the Miami-Dade County Clerk of Courts. Required for name change passport applications. Serving all Miami-Dade communities.",
      url: "https://www.miamidadeclerk.gov/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Miami-Dade County Clerk of Courts. Required for name change passport corrections and legal documentation.",
      url: "https://www.miamidadeclerk.gov/",
    },
  ],
  landmarks: [
    {
      name: "Miami International Airport (MIA)",
      icon: "ri-flight-takeoff-line",
      distance: "~8 miles from downtown Miami",
      desc: "America's primary gateway to Latin America and the Caribbean — 45M+ annual passengers with nonstop service to 100+ international destinations. American Airlines Latin American hub and one of the busiest international airports in the world.",
      url: "https://www.miami-airport.com/",
      schemaType: "Airport",
    },
    {
      name: "PortMiami",
      icon: "ri-ship-line",
      distance: "Downtown Miami — Dodge Island",
      desc: "The Cruise Capital of the World — busiest cruise port on Earth handling 5M+ passengers annually across Carnival, Royal Caribbean, Norwegian, MSC, Disney, and Virgin Voyages. A defining Miami landmark.",
      url: "https://www.miamidade.gov/portmiami",
      schemaType: "TouristAttraction",
    },
    {
      name: "Fort Lauderdale-Hollywood Intl (FLL)",
      icon: "ri-flight-takeoff-line",
      distance: "~28 miles north via I-95",
      desc: "Major alternative airport for South Florida with extensive Caribbean and Latin American service. Popular for cruise passengers connecting to Port Everglades and often more affordable for domestic connections.",
      url: "https://www.broward.org/airport/",
      schemaType: "Airport",
    },
    {
      name: "South Beach",
      icon: "ri-landscape-line",
      distance: "Miami Beach — ~5 miles east of downtown",
      desc: "World-famous beach destination known for Art Deco architecture, turquoise waters, and vibrant nightlife. A major tourism driver bringing millions of international visitors to Miami annually.",
      url: "https://www.miamibeachfl.gov/",
      schemaType: "TouristAttraction",
    },
    {
      name: "Brickell Financial District",
      icon: "ri-building-2-line",
      distance: "Downtown Miami — south of Miami River",
      desc: "Second-largest financial district in the U.S. outside New York. Houses Latin American banking headquarters, multinational corporations, and foreign consulates — driving heavy international business travel.",
      url: "https://www.miamidade.gov/",
      schemaType: "TouristAttraction",
    },
    {
      name: "Little Havana",
      icon: "ri-store-2-line",
      distance: "~3 miles west of downtown — Calle Ocho",
      desc: "Cultural heart of Miami's Cuban-American community. Calle Ocho's restaurants, cigar shops, and Domino Park draw visitors from across the Americas — a defining cultural landmark of Miami.",
      url: "https://www.miamigov.com/",
      schemaType: "TouristAttraction",
    },
    {
      name: "Wynwood Walls",
      icon: "ri-palette-line",
      distance: "~3 miles north of downtown — Wynwood Arts District",
      desc: "Internationally renowned outdoor street art museum and arts district. A major cultural tourism destination attracting visitors from around the world for Art Basel and year-round exhibitions.",
      url: "https://www.thewynwoodwalls.com/",
      schemaType: "TouristAttraction",
    },
    {
      name: "Vizcaya Museum & Gardens",
      icon: "ri-building-line",
      distance: "Coconut Grove — ~5 miles south of downtown",
      desc: "National Historic Landmark estate with Italian Renaissance gardens on Biscayne Bay. A major cultural attraction and one of Miami's most visited historic sites.",
      url: "https://vizcaya.org/",
      schemaType: "TouristAttraction",
    },
  ],
};